import { RSAA } from 'redux-api-middleware';
import getPhysicalConfigurationsURL from 'url-constructors/getPhysicalConfigurationsURL';
import { RootState } from 'redux/rootReducer';
import { Dispatch } from 'redux';
import { TGetRootState, TDispatchResult } from 'types/shared';

const REQUEST = 'opus/physicalConfigurations/REQUEST';
const SUCCESS = 'opus/physicalConfigurations/SUCCESS';
const FAILURE = 'opus/physicalConfigurations/FAILURE';

type PhysicalConfigurationsActionTypes =
  | typeof REQUEST
  | typeof SUCCESS
  | typeof FAILURE;

interface IPhysicalConfigurationsAction {
  type?: PhysicalConfigurationsActionTypes;
  payload: any;
}

interface IPhysicalConfigurationsState {
  pending: boolean;
  fulfilled: boolean;
  rejected: boolean;
  reason: any;
  data: any[];
}

const initialState: IPhysicalConfigurationsState = {
  pending: false,
  fulfilled: false,
  rejected: false,
  reason: null,
  data: [],
};

function reducer(
  state: IPhysicalConfigurationsState = initialState,
  action: IPhysicalConfigurationsAction
): IPhysicalConfigurationsState {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        pending: true,
      };
    case SUCCESS:
      return {
        ...state,
        fulfilled: true,
        pending: false,
        rejected: false,
        reason: null,
        data: action.payload,
      };
    case FAILURE:
      return {
        ...state,
        pending: false,
        fulfilled: false,
        rejected: true,
        reason: action.payload,
      };
    default:
      return state;
  }
}

/**
 * Load customer data from the '/api/physicalConfigurations' endpoint.
 *
 * @see https://github.com/agraboso/redux-api-middleware
 */
function loadPhysicalConfigurations(): TDispatchResult<any> {
  return (dispatch: Dispatch, getState: TGetRootState): any => {
    const { physicalConfigurations } = getState();

    return dispatch({
      [RSAA]: {
        bailout:
          physicalConfigurations.pending || physicalConfigurations.fulfilled,
        types: [
          REQUEST,
          {
            type: SUCCESS,
            payload: async function payload(
              action: IPhysicalConfigurationsAction,
              state: IPhysicalConfigurationsState,
              res: any
            ): Promise<any> {
              const json = await res.json();
              return json;
            },
          },
          FAILURE,
        ],
        endpoint: getPhysicalConfigurationsURL(),
        method: 'GET',
        credentials: 'same-origin',
      },
    });
  };
}

const selectPhysicalConfigurations = (state: RootState): any[] =>
  state.physicalConfigurations.data;

export { loadPhysicalConfigurations, selectPhysicalConfigurations };

export default reducer;
